<script setup lang="ts">
import AppMasthead from '@/components/AppMasthead.vue'
import ImpersonationBanner from '@/components/ImpersonationBanner.vue'
import AppSubnav from '@/components/AppSubnav.vue'
import AppFooter from '@/components/AppFooter.vue'
</script>

<template>
  <div class="bs-page">
    <ImpersonationBanner />
    <AppMasthead />
    <AppSubnav />
    <main class="bs-main">
      <slot />
    </main>
    <AppFooter />
  </div>
</template>
